<template>
  <survey-management />
</template>

<script>
import SurveyManagement from "@/components/surveyManagement/SurveyManagement.vue";

export default {
  name: "Survey",
  components: {
    "survey-management": SurveyManagement,
  },
  data() {
    return {};
  },
  computed: {},
  methods: {},
  mounted() {},
};
</script>
